import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function BlogPage() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  useEffect(() => { api.get("/blog").then((r) => setItems(r.data.items || [])).finally(() => setLoading(false)); }, []);
  return (
    <div className="cs-container py-10" data-testid="blog-page">
      <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-gray-900">Carz Swag Blog</h1>
      <p className="mt-3 text-gray-600">Guides, buying tips and dealership updates.</p>
      {loading ? <div className="mt-8 text-gray-500">Loading…</div> : items.length === 0 ? (
        <div className="mt-10 border border-dashed border-gray-200 rounded-xl p-12 text-center text-gray-500">No posts yet. Check back soon.</div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {items.map((p) => (
            <article key={p.id} className="rounded-xl border border-gray-200 overflow-hidden">
              {p.cover_image && <img src={p.cover_image} alt="" className="w-full aspect-[16/9] object-cover" />}
              <div className="p-5">
                <h3 className="font-display font-bold text-gray-900">{p.title}</h3>
                <p className="mt-2 text-sm text-gray-600 line-clamp-3">{p.excerpt}</p>
                <div className="mt-3 text-xs text-gray-400">{new Date(p.created_at).toLocaleDateString()}</div>
              </div>
            </article>
          ))}
        </div>
      )}
    </div>
  );
}
